import { render, staticRenderFns } from "./ShopcartBottom.vue?vue&type=template&id=86908058&scoped=true&"
import script from "./ShopcartBottom.vue?vue&type=script&lang=js&"
export * from "./ShopcartBottom.vue?vue&type=script&lang=js&"
import style0 from "./ShopcartBottom.vue?vue&type=style&index=0&id=86908058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86908058",
  null
  
)

export default component.exports